import { Link, useParams } from "react-router-dom";

import { routes } from "~/router";

const CrawlModalContent = ({ crawlType }: { crawlType: "soft" | "force" }) => {
  const { id } = useParams();

  return (
    <>
      <p>
        {crawlType === "soft"
          ? "We will crawl new and previously failed pages. Additionally we will crawl expired pages that were crawled longer than 7 days ago. This may temporarily spike traffic on your website."
          : "We will crawl all pages of your website looking through your site structure all over again. This may temporarily spike traffic on your website."}
      </p>

      <p>
        Note that the frequency of crawler usage affects your invoice. You can
        always adjust it in{" "}
        {id ? (
          <Link to={routes.site.settings.tab({ id, tabId: "crawler" })}>
            site settings
          </Link>
        ) : (
          "site settings"
        )}
        .
      </p>
    </>
  );
};

export default CrawlModalContent;
